import { h, Component } from 'preact'
import CodeMirror from 'codemirror'
import 'codemirror/mode/htmlmixed/htmlmixed'
import 'codemirror/mode/css/css'

interface Props {
  className?: string,
  defaultValue?: string,
  options?: CodeMirror.EditorConfiguration,
  onChange: (data: string) => void
}

interface State {
  content: string
}

export default class extends Component<Props, State> {

  options: CodeMirror.EditorConfiguration
  codeMirror: CodeMirror
  mounted?: boolean
  textareaNode: HTMLElement | undefined

  constructor (props: Props) {
    super(props)

    this.state = {
      content: props.defaultValue || ''
    }

    const defaultOptions = {
      lineNumbers: true,
      mode: 'text/css',
      selectionPointer: true,
      autoRefresh: true,
      autoResize: true,
      lineWrapping: true
    }

    this.options = Object.assign(defaultOptions, props.options || {}) 
    this.onChange = this.onChange.bind(this)
  }

  componentWillReceiveProps(nextProps: Readonly<Props>): void {
    if (typeof nextProps.defaultValue === 'string' && nextProps.defaultValue !== this.props.defaultValue && nextProps.defaultValue !== this.state.content) {
      this.setState({ content: nextProps.defaultValue })
      this.codeMirror.setValue(nextProps.defaultValue)
    }
  }

  onChange (doc: CodeMirror, _: CodeMirror.EditorChange) {
    if (this.mounted) {this.props.onChange(doc.getValue())

    this.setState({
      content: doc.getValue()
    })}
  }

  componentDidMount () {
    this.codeMirror = CodeMirror.fromTextArea(this.textareaNode, this.options)

    this.mounted = true
    this.codeMirror.on('change', this.onChange)

    this.codeMirror.setValue(this.state.content)
  }
componentWillUnmount() {
    this.mounted = false
  }
  render ({ className } : Props) {
    return (
      <div>
        <textarea class={className} spellcheck={false} ref={ref => { this.textareaNode = ref }} />
      </div>
    )
  }
}
